import { useCatalogActionsContext } from "@components/Actions/CatalogActions/CatalogActionsContext";
import ItemExport, { type ExportFormat } from "@ext/wordExport/components/ItemExport";

interface ExportMenuItemProps {
	exportFormat: ExportFormat;
}

const ExportMenuItem = ({ exportFormat }: ExportMenuItemProps) => {
	const { catalogName } = useCatalogActionsContext();

	return <ItemExport exportFormat={exportFormat} fileName={catalogName} />;
};

export default ExportMenuItem;
